import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=72978cd2&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72978cd2')) {
      api.createRecord('72978cd2', component.options)
    } else {
      api.reload('72978cd2', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=72978cd2&", function () {
      api.rerender('72978cd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2go3VxX00tbNj/JS/comp/ImgFallback.vue"
export default component.exports